import { Typography } from '@mui/material';
import {
  ServiceAgreementRole,
  ServiceAgreementsResponse,
} from 'ogp/services/service-agreements.types';
import { useTranslation } from 'react-i18next';
import { LwBlockGridContainer } from 'redesign';
import { CustomerCard } from '../client-card/customer-card';
import { SupplierCard } from '../client-card/supplier-card';

const agreementCards = {
  LENDER: CustomerCard,
  BORROWER: SupplierCard,
};

export const ServiceAgreementList = ({
  data,
  role,
}: {
  data: ServiceAgreementsResponse;
  role: ServiceAgreementRole;
}) => {
  const { t } = useTranslation('ogp-screen-specific');
  const Card = agreementCards[role];

  if (data.length === 0) {
    return <Typography>{t('collegial-lending-page.no-service-agreements')}</Typography>;
  }

  return (
    <LwBlockGridContainer container spacing={4}>
      {data.map((item) => (
        <Card key={item.id} serviceAgreement={item} />
      ))}
    </LwBlockGridContainer>
  );
};
